module.exports = "/packs/icon-exam-6ccbd5582aa8d1b9607aeab26e5d3bb1.png";